<template>
  <technical-page-wrapper>
    <technical-section
      :title="t('work')"
      :description="t('serviceWillBeRestoredSoon')"
      image="/img/technical_works.webp"
    >
      <template #action>
        <ol-button
          :disabled="loading"
          left-icon="refresh"
          :label="t('refresh')"
          color="gray-night-100"
          @click="updateStatusServer"
        />
      </template>
    </technical-section>
  </technical-page-wrapper>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useQuery } from '@vue/apollo-composable'
import { OlButton } from '@gamesite/olimp-core'
import TechnicalSection from 'components/technical/TechnicalSection.vue'
import TechnicalPageWrapper from 'components/technical/TechnicalPageWrapper.vue'
import { consoleLogAPI } from 'src/common/functions'
import { notification } from 'src/core/hooks/notifications'
import getUnderdev from 'src/apollo/queries/getUnderdev.gql'

const { t } = useI18n()

const loading = ref(false)
function updateStatusServer() {
  loading.value = true

  const { onResult, onError } = useQuery(getUnderdev, {}, { fetchPolicy: 'network-only' })

  onResult(({ data }) => {
    if (data?.siteInfo?.underDev === false) {
      location.reload()
      loading.value = false
    }
  })

  onError((e) => {
    consoleLogAPI(e)
    notification({ type: 'warning', text: t('serverErrorTryAgain') })
    loading.value = false
  })
}
</script>

<style scoped lang="scss"></style>
